<template>
  <app-section-wrap
    :modifier="'main-nav'"
    v-click-outside="closeAllMenus"
  >
    <nav column="12">
      <ul>
        <template v-for="(parentRoute, i) in routesToShow">
          <li
            v-if="parentRoute.label"
            class="has-children"
            :class="mainNavClass(parentRoute)"
            @mouseover="setNavActive(parentRoute.label, true)"
            @mouseout="setNavActive(parentRoute.label, false)"
            @keyup.enter="setNavActive(parentRoute.label, !navIsActive(parentRoute.label))"
            :key="i"
          >
            <a
              href="javascript:void(0)"
              class="nav-label"
              :class="parentRoute.className"
            >
              <AttestationNotificationBadge v-if="parentRoute.hasBadge && showAttestationBadge"/>
              {{ parentRoute.label }}
              <font-awesome-icon
                icon="caret-down"
                aria-label="Expand submenu"
              />
            </a>
            <ul class="dropdown">
              <li
                v-for="(route, i) in parentRoute.dropdownRoutes"
                :key="i"
                :class="{'has-badge': route.hasBadge && showAttestationBadge }"
              >
                <AttestationNotificationBadge v-if="route.hasBadge && showAttestationBadge"/>
                <router-link
                  :to="getRoute(route)"
                  :class="parentRoute.className"
                >
                  {{ route.content }}
                </router-link>

                <!-- Append these routes to the end -->

                <router-link
                  v-if="
                    isInternalUser &&
                      parentRoute.label === 'more' &&
                      i === parentRoute.dropdownRoutes.length - 1
                  "
                  :to="{
                    name: 'client-onboarding-management',
                  }"
                >
                  Client Onboarding Management
                </router-link>
                <a
                  @click="bookmark"
                  v-if="
                    parentRoute.label === 'more' &&
                      i === parentRoute.dropdownRoutes.length - 1
                  "
                  href="javascript:void(0)"
                >
                  Bookmark this page
                </a>
                <router-link
                  v-if="
                    !isInternalUser &&
                      parentRoute.label === 'more' &&
                      i === parentRoute.dropdownRoutes.length - 1
                  "
                  :to="{
                    name: 'user-profile',
                    params: { userId: $store.state.auth.userId },
                  }"
                >
                  My Profile
                </router-link>
                <a
                  v-if="
                    parentRoute.label === 'more' &&
                      i === parentRoute.dropdownRoutes.length - 1
                  "
                  @click="$isSsoUser ? logoutWithSso() : logout()"
                  id="logout"
                  href="javascript:void(0)"
                >
                  Logout
                </a>
              </li>
            </ul>
          </li>
          <li
            v-else
            :key="i"
            :class="'nav-' + parentRoute.content"
          >
            <router-link
              :to="{ name: parentRoute.name }"
              :class="parentRoute.className"
            >{{ parentRoute.content }}</router-link>
          </li>
        </template>
      </ul>
    </nav>
  </app-section-wrap>
</template>

<script>
import AppSectionWrap from '@molecules/SectionWrap.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import logouttable from '@mixins/logouttable'
import { mapGetters } from 'vuex'
import { syncDeepClone } from '@utils'
import AttestationNotificationBadge from '@organisms/v2/AttestationNotificationBadge.vue'

export default {
  components: {
    AppSectionWrap,
    AttestationNotificationBadge,
    FontAwesomeIcon,
  },
  mixins: [logouttable],
  methods: {
    closeAllMenus() {
      Object.keys(this.activeNavs).forEach((nav) => {
        this.activeNavs[nav] = false
      })
    },
    navIsActive(navId) {
      return this.activeNavs[navId]
    },
    setNavActive(navId, isActive) {
      this.$set(this.activeNavs, navId, isActive)
    },
    mainNavClass(parentRoute) {
      return {
        [`nav-${parentRoute.label}`]: true,
        active: this.navIsActive(parentRoute.label)
      }
    },
    getRoute(route) {
      let routeConfig = { name: route.name }
      if (route.params) {
        routeConfig.params = route.params
      }

      if (route.query) {
        routeConfig.query = route.query
      }

      return routeConfig
    },
    bookmark(e) {
      let bookmarkURL = window.location.href
      let bookmarkTitle = document.title
      let bookmarklet = e.target

      if (window.sidebar && window.sidebar.addPanel) {
        // Firefox <=22
        window.sidebar.addPanel(bookmarkTitle, bookmarkURL, '')
      } else if (
        (window.sidebar && /Firefox/i.test(navigator.userAgent)) ||
        (window.opera && window.print)
      ) {
        let bookmarkUrlAttr = document.createAttribute('href')
        let bookmarkTitleAttr = document.createAttribute('title')
        let relAttr = document.createAttribute('rel')

        bookmarkUrlAttr.value = bookmarkURL
        bookmarkTitleAttr.value = bookmarkTitle
        relAttr.value = 'sidebar'

        bookmarklet.attributes.setNamedItem(bookmarkTitleAttr)
        bookmarklet.attributes.setNamedItem(bookmarkUrlAttr)
        bookmarklet.attributes.setNamedItem(relAttr)
        bookmarklet.removeEventListener('click', this.bookmark, false)

        return true
      } else if (window.external && 'AddFavorite' in window.external) {
        // IE Favorites
        window.external.AddFavorite(bookmarkURL, bookmarkTitle)
      } else {
        // Other browsers (mainly WebKit & Blink - Safari, Chrome, Opera 15+)
        alert(
          'Press ' +
          (/Mac/i.test(navigator.platform) ? 'Cmd' : 'Ctrl') +
          '+D to bookmark this page.'
        )
      }

      return false
    },
    beginAttestationPoll() {
      if(this.shouldPollAttestationCount) {
          this.$store.dispatch('CYCLE_ATTESTATION_COUNT');
      }
    },
    pollAttestationUnseenCount() {
      if(this.shouldPollAttestationCount) {
        this.$store.dispatch('FETCH_ATTESTATION_UNSEEN_COUNT');
      }
    }
  },
  mounted() {
    this.pollAttestationUnseenCount();
    this.beginAttestationPoll();
  },
  data() {
    const billingDropdownRoutes = [{ name: 'billing-overview', content: 'Billing Home' }]
    if (this.paymentsAvailable || true) {
      billingDropdownRoutes.push({ name: 'billing-manage-payment-methods', content: 'Manage Payment Methods' })
      billingDropdownRoutes.push({ name: 'billing-manage-auto-payment-methods', content: 'Manage Auto Payment Methods' })
    }

    return {
      activeNavs: {},
      routes: [
        {
          name: 'dashboard',
          content: 'home',
          className: '-leaf'
        },
        {
          label: 'billing',
          className: '-sun',
          dropdownRoutes: billingDropdownRoutes
        },
        {
          label: 'member management',
          className: '-lips',
          dropdownRoutes: [
            {
              name: 'member-management',
              content: 'member management home'
            },
            {
              name: 'member-transactions',
              content: 'transaction summary'
            },
            {
              name: 'add-new-family',
              content: 'add subscriber',
              query: {
                clear: true
              }
            },
            {
              name: 'enrollment-report',
              content: 'enrollment report'
            }
          ]
        },

        {
          name: 'reporting-page',
          content: 'reporting',
          className: '-grape'
        },
        {
          name: 'resources',
          content: 'resources',
          className: '-moon'
        },
        {
          name: 'contacts',
          content: 'contacts'
        },
        {
          label: 'more',
          className: 'badged',
          hasBadge: true,
          dropdownRoutes: [
            {
              name: 'user-management',
              content: 'administrator management'
            },
            {
              name: 'locator',
              content: 'provider locator'
            },
            {
              name: 'attestations-list',
              content: 'attestations',
              hasBadge: true,
            },
            {
              name: 'open-enrollment',
              content: 'open enrollment'
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'isInternalUser',
      'loggedIn',
      'minimumAccess', 
      'accountType', 
      'attestationConfirmationsPending',
      'attestationRequestsPending',
      'userRole'
      ]),
    hasNoPerms() {
      return !Object.values(this.minimumAccess).includes(true);
    },
    isAdmin() {
      return (this.userRole.userRole === 'ROLE_EMGROUPSADMIN' || this.userRole.userRole === 'ROLE_EMGROUPSCLIENT');
    },
    showAttestationBadge() {
      if(['B', 'T'].includes(this.accountType)) {
        if(this.attestationConfirmationsPending > 0) {
          return true;
        }
      }
      else if(this.accountType === 'C' && this.attestationRequestsPending > 0) {
        return true;
      }
      return false;
    },
    shouldPollAttestationCount() {
      return this.loggedIn && !this.isInternalUser && this.accountType !== 'R';
    },
    routesToShow() {
      const routes = syncDeepClone(this.routes)
      const filteredRoutes = []
      routes.map(route => {
        if (
          !this.minimumAccess.memberMaintenanceAllowed &&
          !this.minimumAccess.memberSearchAllowed &&
          route.label === 'member management'
        ) {
          return
        }
        if (
          !this.minimumAccess.memberMaintenanceAllowed &&
          this.minimumAccess.memberSearchAllowed
        ) {
          if (route.label === 'member management') {
            route.dropdownRoutes = route.dropdownRoutes.filter(subRoute => {
              return (subRoute.name !== 'add-new-family' && subRoute.name !== 'member-transactions')
            })
          }
        }
        if (
          !this.minimumAccess.viewInvoicesAllowed &&
          !this.minimumAccess.claimsAllowed &&
          route.label == 'billing'
        ) {
          return
        }
        if (!this.minimumAccess.createGroupUsersAllowed && route.label == 'more') {
          route.dropdownRoutes = route.dropdownRoutes.filter(subRoute => {
            return subRoute.name != 'user-management';
          });
          if (this.$store.getters['accountType'] === 'C') {
            route.dropdownRoutes = route.dropdownRoutes.filter(subRoute => subRoute.content !== 'attestations');
          }
        }
        
        if (route.label === 'more' && this.$store.getters['accountType'] === 'R') {
          route.dropdownRoutes = route.dropdownRoutes.filter(r => r.content !== 'attestations');
        }

        if (route.label === 'more' && !(this.isAdmin)) {
          route.dropdownRoutes = route.dropdownRoutes.filter(r => r.content !== 'attestations');
        }

        if (route.label === 'more' && this.hasNoPerms) {
          // do not show Provider Locator or Open Enrollment links
          //    for Broker / TPA users.
          route.dropdownRoutes = route.dropdownRoutes.filter((ddr) => {
            return !(ddr.name === 'locator' || ddr.name === 'open-enrollment');
          });
        }

        // do not show Enrollment Report for users with no Enrollment perms
        if(route.label === 'member management' && !this.minimumAccess.enrollmentAllowed) {
          route.dropdownRoutes = route.dropdownRoutes.filter(r => r.name !== 'enrollment-report');
        }

        if (this.hasNoPerms) {
          if (route.content === 'contacts' || route.content === 'reporting') {
            return;
          }
        }

        filteredRoutes.push(route);
      });
      return filteredRoutes
    }
  },
  beforeDestroy() {
    if(this.$store.getters['attestationPollingHandle']) {
      clearInterval(this.$store.getters['attestationPollingHandle']);
    }
  },
}
</script>
